module.exports = __webpack_public_path__ + "assets/img/star-4.37899d78.svg";